import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Menu} from "../model/menu";
import {MenuService} from "../service/menu.service";

@Injectable()
export class MenuResolve implements Resolve<Menu> {
    constructor(private menuService: MenuService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Menu> {
        return this.menuService.getById(route.params.id);
    }
}